import { FocusEventHandler, FormEventHandler } from 'react'
import { Metadata, CaptureWithContext } from '.'

const EVENT_CATEGORY = 'input'
const EVENT_INPUT_FOCUSED = 'input_focused'
const EVENT_INPUT_BLURRED = 'input_blurred'
const EVENT_INPUT_CHANGED = 'input_changed'

export const trackInputFocus =
  (capture: CaptureWithContext) =>
  (
    metadata: Metadata,
    onFocus?: FocusEventHandler | ((event?: unknown) => Promise<void>),
  ): FocusEventHandler =>
  (event) => {
    capture(EVENT_INPUT_FOCUSED, {
      ...metadata,
      category: EVENT_CATEGORY,
    })

    void onFocus?.(event)
  }

export const trackInputBlur =
  (capture: CaptureWithContext) =>
  (
    metadata: Metadata,
    onBlur?: FocusEventHandler | ((event?: unknown) => Promise<void>),
  ): FocusEventHandler =>
  (event) => {
    capture(EVENT_INPUT_BLURRED, {
      ...metadata,
      category: EVENT_CATEGORY,
    })

    void onBlur?.(event)
  }

export const trackInputChange =
  (capture: CaptureWithContext) =>
  (
    metadata: Metadata,
    onChange?: FormEventHandler | ((event?: unknown) => Promise<void>),
  ): FormEventHandler =>
  (event) => {
    const payload = {
      ...metadata,
      category: EVENT_CATEGORY,
    }

    capture(EVENT_INPUT_CHANGED, payload)

    void onChange?.(event)
  }

export const trackInput =
  (capture: CaptureWithContext) =>
  (
    metadata: Metadata,
    events?: {
      onBlur?: FocusEventHandler
      onFocus?: FocusEventHandler
      onChange?: FormEventHandler
    },
  ) => ({
    onBlur: trackInputBlur(capture)(metadata, events?.onBlur),
    onFocus: trackInputFocus(capture)(metadata, events?.onFocus),
    onChange: trackInputChange(capture)(metadata, events?.onChange),
  })
